import { useMemo } from "react";
import { NotFoundView } from "../components/NotFoundView";
import { Seo } from "../components/Seo";
import { useLocale } from "../i18n";
import { buildPrivateHead } from "../seo";

/** A page that does not exist must never be indexed under a title that does. */
export function NotFoundPage() {
  const locale = useLocale();
  const head = useMemo(() => buildPrivateHead("Page not found", locale), [locale]);

  return (
    <>
      <Seo head={head} />
      <NotFoundView />
    </>
  );
}
